import { useEffect } from "react";
import { CONTACT, POSITIONING, BG } from "@/data/content";
import { normalizeBrand } from "@/lib/brand";

export default function Seo({ title, description, path = "/", noindex = false }) {
  useEffect(() => {
    const fullTitle = `${normalizeBrand(title)} · ERAM DIGITAL`;
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", normalizeBrand(description));
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", normalizeBrand(description));
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "ERAM DIGITAL");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", normalizeBrand(description));
    setMeta("property", "og:image", new URL(BG.hero, process.env.REACT_APP_BACKEND_URL).href);
    let schema = document.head.querySelector("script[data-company-schema]");
    if (!schema) {
      schema = document.createElement("script");
      schema.type = "application/ld+json";
      schema.dataset.companySchema = "true";
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({
      "@context": "https://schema.org", "@type": "Organization", name: "ERAM DIGITAL",
      description: POSITIONING, email: CONTACT.email, telephone: CONTACT.phone,
      parentOrganization: { "@type": "Organization", name: "ERAM HOLDINGS" },
      address: { "@type": "PostalAddress", streetAddress: "Khobar Business Gate Tower A", addressLocality: "Al Khobar", postalCode: "31952", addressCountry: "SA" },
      areaServed: ["Saudi Arabia", "United Arab Emirates", "Bahrain"],
    });
  }, [title, description, path, noindex]);

  return null;
}
